<template>
  <div v-if="loading">
    {{ notify() }}
  </div>
</template>
<script>
import swal from "sweetalert2";

export default {
  computed: {
    loading() {
      return this.$store.state.registration.loading;
    },
  },
  methods: {
    notify() {
      swal.fire({
        title: "Processing...",
        showConfirmButton: false,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
    },
  },
};
</script>
